export const bongo3Products = [
  {
    id: 'bongo3-1',
    name: 'BON001',
    description: 'HEAD LAMP',
    partNumber: '92101-4E500 L / 92102-4E500 R',
    price: 45000,
    image: 'https://public.readdy.ai/ai/img_res/3ba4ee8a71a1e373648fe159f0729512.jpg',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-2',
    name: 'BON002',
    description: 'HEAD LAMP',
    partNumber: '92101-4E025 L / 92102-4E025 R',
    price: 45000,
    image: 'https://readdy.ai/api/search-image?query=modern%20truck%20headlamp%20light%20assembly%20with%20clear%20lens%20and%20chrome%20housing%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-headlamp-2&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-3',
    name: 'BON003',
    description: 'HEAD LAMP',
    partNumber: '92101-4E002 L / 92102-4E002 R',
    price: 45000,
    image: 'https://readdy.ai/api/search-image?query=modern%20truck%20headlamp%20light%20assembly%20with%20clear%20lens%20and%20chrome%20housing%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-headlamp-3&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-4',
    name: 'BON004',
    description: 'HEAD LAMP',
    partNumber: '92101-4E700 L / 92102-4E700 R',
    price: 45000,
    image: 'https://readdy.ai/api/search-image?query=modern%20truck%20headlamp%20light%20assembly%20with%20clear%20lens%20and%20chrome%20housing%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-headlamp-4&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-5',
    name: 'BON005',
    description: 'BUMPER',
    partNumber: '86510-4E010',
    price: 85000,
    image: 'https://readdy.ai/api/search-image?query=truck%20front%20bumper%20chrome%20metal%20automotive%20part%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-bumper&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-6',
    name: 'BON006',
    description: 'FOG LAMP',
    partNumber: '92201-4E500 L / 92202-4E500 R',
    price: 35000,
    image: 'https://readdy.ai/api/search-image?query=truck%20fog%20lamp%20light%20assembly%20round%20shape%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-foglamp&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-7',
    name: 'BON007',
    description: 'FOG LAMP',
    partNumber: 'FOG LAMP LED',
    price: 38000,
    image: 'https://readdy.ai/api/search-image?query=modern%20LED%20fog%20lamp%20light%20assembly%20for%20truck%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-foglamp-led&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-8',
    name: 'BON008',
    description: 'FOG LAMP LED',
    partNumber: '-',
    price: 38000,
    image: 'https://readdy.ai/api/search-image?query=modern%20LED%20fog%20lamp%20light%20assembly%20for%20truck%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-foglamp-led-2&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-9',
    name: 'BON009',
    description: 'FOG LAMP COVER',
    partNumber: '-',
    price: 15000,
    image: 'https://readdy.ai/api/search-image?query=truck%20fog%20lamp%20cover%20plastic%20trim%20piece%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-foglamp-cover&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-10',
    name: 'BON010',
    description: 'DAY LIGHT',
    partNumber: '-',
    price: 32000,
    image: 'https://readdy.ai/api/search-image?query=LED%20daytime%20running%20light%20strip%20for%20truck%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-daylight&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-11',
    name: 'BON011',
    description: 'TAIL LAMP',
    partNumber: '92401-4E000 L / 92402-4E000 R',
    price: 42000,
    image: 'https://readdy.ai/api/search-image?query=truck%20tail%20lamp%20light%20assembly%20red%20lens%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-taillamp&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-12',
    name: 'BON012',
    description: 'TAIL LAMP LED',
    partNumber: '92401-4E000LED L / 92402-4E000LED R',
    price: 48000,
    image: 'https://readdy.ai/api/search-image?query=modern%20LED%20tail%20lamp%20light%20assembly%20for%20truck%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-taillamp-led&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-13',
    name: 'BON013',
    description: 'MIRROR',
    partNumber: '87610-4E000 L / 87620-4E000 R',
    price: 55000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20assembly%20black%20housing%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-1&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-14',
    name: 'BON014',
    description: 'MIRROR',
    partNumber: '87610-4E600 L / 87620-4E600 R',
    price: 55000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20assembly%20black%20housing%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-2&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-15',
    name: 'BON015',
    description: 'MIRROR',
    partNumber: '87610-4E700 L / 87620-4E700 R',
    price: 55000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20assembly%20black%20housing%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-3&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-16',
    name: 'BON014B',
    description: 'MIRROR',
    partNumber: '87610-4E600 L / 87620-4E600 R',
    price: 55000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20assembly%20black%20housing%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-14b&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-17',
    name: 'BON015B',
    description: 'MIRROR',
    partNumber: '87610-4E700 L / 87620-4E700 R',
    price: 55000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20assembly%20black%20housing%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-15b&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-18',
    name: 'BON014M',
    description: 'MIRROR',
    partNumber: '87610-4E600 L / 87620-4E600 R',
    price: 55000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20assembly%20black%20housing%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-14m&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-19',
    name: 'BON015M',
    description: 'MIRROR',
    partNumber: '87610-4E700 L / 87620-4E700 R',
    price: 55000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20assembly%20black%20housing%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-15m&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-20',
    name: 'BON014C',
    description: 'MIRROR CHROME',
    partNumber: '87610-4E600 L / 87620-4E600 R',
    price: 58000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20assembly%20chrome%20housing%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-chrome&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-21',
    name: 'BON054',
    description: 'Mirror W/O Lamp',
    partNumber: '87610-4E500 L / 87620-4E500 R',
    price: 52000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20without%20lamp%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-wo-lamp&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-22',
    name: 'BON054C',
    description: 'Mirror W/O Lamp Chrome',
    partNumber: '-',
    price: 55000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20chrome%20without%20lamp%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-wo-lamp-chrome&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-23',
    name: 'BON016',
    description: 'GRILLE CHROME',
    partNumber: '-',
    price: 68000,
    image: 'https://readdy.ai/api/search-image?query=truck%20front%20grille%20chrome%20finish%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-grille-chrome&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-24',
    name: 'BON017',
    description: 'GRILLE',
    partNumber: '86350-4E500',
    price: 65000,
    image: 'https://readdy.ai/api/search-image?query=truck%20front%20grille%20black%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-grille&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-25',
    name: 'BON018',
    description: 'LED GRILLE BLACK',
    partNumber: '-',
    price: 72000,
    image: 'https://readdy.ai/api/search-image?query=truck%20LED%20grille%20black%20finish%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-led-grille-black&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-26',
    name: 'BON019',
    description: 'LED GRILLE CHROME',
    partNumber: '-',
    price: 75000,
    image: 'https://readdy.ai/api/search-image?query=truck%20LED%20grille%20chrome%20finish%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-led-grille-chrome&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-27',
    name: 'BON020',
    description: 'LED GRILLE',
    partNumber: '-',
    price: 70000,
    image: 'https://readdy.ai/api/search-image?query=truck%20LED%20grille%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-led-grille&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-28',
    name: 'BON021',
    description: 'HOOD',
    partNumber: '86400-4E510',
    price: 125000,
    image: 'https://readdy.ai/api/search-image?query=truck%20hood%20panel%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-hood-1&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-29',
    name: 'BON022',
    description: 'HOOD',
    partNumber: '86400-4E000',
    price: 125000,
    image: 'https://readdy.ai/api/search-image?query=truck%20hood%20panel%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-hood-2&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-30',
    name: 'BON055',
    description: 'HOOD',
    partNumber: '86400-4E700',
    price: 125000,
    image: 'https://readdy.ai/api/search-image?query=truck%20hood%20panel%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-hood-3&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-31',
    name: 'BON023',
    description: 'BUMPER',
    partNumber: '86511-4E010',
    price: 88000,
    image: 'https://readdy.ai/api/search-image?query=truck%20bumper%20section%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-bumper-23&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-32',
    name: 'BON024',
    description: 'BUMPER',
    partNumber: '86511-4E552',
    price: 88000,
    image: 'https://readdy.ai/api/search-image?query=truck%20bumper%20section%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-bumper-24&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-33',
    name: 'BON025',
    description: 'BUMPER GUARD',
    partNumber: '86550-4E700',
    price: 45000,
    image: 'https://readdy.ai/api/search-image?query=truck%20bumper%20guard%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-bumper-guard&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-34',
    name: 'BON026',
    description: 'BUMPER SUPPORT',
    partNumber: '86530-4E600',
    price: 38000,
    image: 'https://readdy.ai/api/search-image?query=truck%20bumper%20support%20bracket%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-bumper-support&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-35',
    name: 'BON027',
    description: 'HANDLE',
    partNumber: '82650-4E000 L / 82660-4E000 R',
    price: 28000,
    image: 'https://readdy.ai/api/search-image?query=truck%20door%20handle%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-handle-27&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-36',
    name: 'BON027N',
    description: 'HANDLE',
    partNumber: '82650-4E000 L / 82660-4E000 R',
    price: 28000,
    image: 'https://readdy.ai/api/search-image?query=truck%20door%20handle%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-handle-27n&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-37',
    name: 'BON028',
    description: 'HANDLE',
    partNumber: '-',
    price: 28000,
    image: 'https://readdy.ai/api/search-image?query=truck%20door%20handle%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-handle-28&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-38',
    name: 'BON029',
    description: 'HANDLE',
    partNumber: '82610-4E000 L / 82620-4E000 R',
    price: 28000,
    image: 'https://readdy.ai/api/search-image?query=truck%20door%20handle%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-handle-29&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-39',
    name: 'BON030',
    description: 'HANDLE',
    partNumber: '83650-4E020 L / 83660-4E020 R',
    price: 28000,
    image: 'https://readdy.ai/api/search-image?query=truck%20door%20handle%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-handle-30&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-40',
    name: 'BON031',
    description: 'AIR FILTER',
    partNumber: '28110-4E000',
    price: 32000,
    image: 'https://readdy.ai/api/search-image?query=truck%20air%20filter%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-air-filter&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-41',
    name: 'BON032',
    description: 'FENDER',
    partNumber: '86301-4E000 L / 86302-4E000 R',
    price: 95000,
    image: 'https://readdy.ai/api/search-image?query=truck%20fender%20panel%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-fender&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-42',
    name: 'BON033',
    description: 'WATER TANK',
    partNumber: '25430-4E010',
    price: 78000,
    image: 'https://readdy.ai/api/search-image?query=truck%20water%20tank%20reservoir%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-water-tank&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-43',
    name: 'BON034',
    description: 'MUD GUARD',
    partNumber: '61210-4E000 L / 61220-4E000 R',
    price: 35000,
    image: 'https://readdy.ai/api/search-image?query=truck%20mud%20guard%20flap%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mud-guard-34&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-44',
    name: 'BON035',
    description: 'MUD GUARD',
    partNumber: '86811-4E001 L / 86821-4E001 R',
    price: 35000,
    image: 'https://readdy.ai/api/search-image?query=truck%20mud%20guard%20flap%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mud-guard-35&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-45',
    name: 'BON036',
    description: 'BUMPER GRILLE',
    partNumber: '86561-4E500 / 86562-4E500',
    price: 42000,
    image: 'https://readdy.ai/api/search-image?query=truck%20bumper%20grille%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-bumper-grille&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-46',
    name: 'BON038',
    description: 'DOOR',
    partNumber: '76003-4E000 L / 76004-4E000 R',
    price: 185000,
    image: 'https://readdy.ai/api/search-image?query=truck%20door%20panel%20assembly%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-door&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-47',
    name: 'BON056',
    description: 'DOOR SILL PANEL',
    partNumber: '-',
    price: 45000,
    image: 'https://readdy.ai/api/search-image?query=truck%20door%20sill%20panel%20trim%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-door-sill&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-48',
    name: 'BON012C',
    description: 'TAILLAMP LENS',
    partNumber: '-',
    price: 25000,
    image: 'https://readdy.ai/api/search-image?query=truck%20tail%20lamp%20lens%20cover%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-taillamp-lens&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-49',
    name: 'BON013GB',
    description: 'MIRROR GLASS BIG',
    partNumber: '-',
    price: 18000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20glass%20big%20size%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-glass-big&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-50',
    name: 'BON013GM',
    description: 'MIRROR GLASS SMALL',
    partNumber: '-',
    price: 15000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20glass%20small%20size%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-glass-small&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-51',
    name: 'BON014G',
    description: 'MIRROR GLASS',
    partNumber: '-',
    price: 16000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20glass%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-glass&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-52',
    name: 'BON014L',
    description: 'MIRROR LAMP WHITE',
    partNumber: '-',
    price: 22000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20lamp%20white%20LED%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-lamp-white&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-53',
    name: 'BON015L',
    description: 'MIRROR LAMP BLACK',
    partNumber: '-',
    price: 22000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20lamp%20black%20LED%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-lamp-black&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-54',
    name: 'BON059',
    description: 'MIRROR',
    partNumber: '87640-4E001',
    price: 55000,
    image: 'https://readdy.ai/api/search-image?query=truck%20side%20mirror%20assembly%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-mirror-59&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  },
  {
    id: 'bongo3-55',
    name: 'BON060',
    description: 'WHEEL PANEL',
    partNumber: '87752-4E010 / 87751-4E000',
    price: 38000,
    image: 'https://readdy.ai/api/search-image?query=truck%20wheel%20panel%20cover%20on%20white%20background%20professional%20product%20photography&width=400&height=400&seq=bongo3-wheel-panel&orientation=squarish',
    category: 'KIA BONGO 3 12-22',
    inStock: true
  }
];
